import React, { useState } from 'react';
import Reveal from '../components/ui/Reveal';
import { Field } from '../components/ui/Field';
import { PrimaryAction } from '../components/PageHeader';

interface NewNodeFormProps {
  /** Managers add accepted topics; members propose. */
  canManage: boolean;
  onAdd: (title: string) => Promise<boolean>;
  autoFocus?: boolean;
}

const NewNodeForm: React.FC<NewNodeFormProps> = ({ canManage, onAdd, autoFocus }) => {
  const [title, setTitle] = useState('');
  const [busy, setBusy] = useState(false);
  const [focused, setFocused] = useState(false);

  const submit = async () => {
    const clean = title.trim();
    if (!clean || busy) return;
    setBusy(true);
    const ok = await onAdd(clean);
    setBusy(false);
    if (ok) setTitle('');
  };

  return (
    <div className="mt-6">
      <div className="flex items-center gap-2">
        <Field
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              submit();
            } else if (e.key === 'Escape') {
              e.preventDefault();
              setTitle('');
            }
          }}
          autoFocus={autoFocus}
          maxLength={200}
          aria-label="Add a topic"
          placeholder="Add a topic"
          className="min-h-[40px] flex-1"
        />
        <PrimaryAction onClick={submit} disabled={!title.trim() || busy}>
          {canManage ? 'Add' : 'Propose'}
        </PrimaryAction>
      </div>
      <Reveal show={!canManage && focused}>
        <p className="mt-1.5 px-4 text-xs text-on-surface-variant">
          Your topic waits in Proposed until the owner or a plan admin accepts it.
        </p>
      </Reveal>
    </div>
  );
};

export default NewNodeForm;
